import { IMobileShortcutKeyManagerInjectable } from '../../core/interface';
import BaseShortcutKeyManagerInjectable from '../base/manager-injectable';

export default class MobileShortcutKeyManagerInjectable
    extends BaseShortcutKeyManagerInjectable
    implements IMobileShortcutKeyManagerInjectable {

}
